import axios from 'axios';
import * as AxiosHelper from './AxiosHelper';


export function get(baseUrl, queryData) {
    var url = AxiosHelper.getUrl(baseUrl, queryData);
    return axios.get(url);
}

export function post(baseUrl, bodyData) {
    var url = AxiosHelper.getUrl(baseUrl, null);
    return axios.post(url, bodyData);
}

export function put(baseUrl, bodyData) {
    var url = AxiosHelper.getUrl(baseUrl, null);
    return axios.put(url, bodyData);
}

export function patch(baseUrl, bodyData) {
    var url = AxiosHelper.getUrl(baseUrl, null);
    return axios.patch(url, bodyData);
}

export function del(baseUrl, queryData) {
    var url = AxiosHelper.getUrl(baseUrl, queryData);
    return axios.delete(url);
}

export function getWithApiKey(baseUrl, queryData, apiKey, apiSecret) {
    var url = AxiosHelper.getUrl(baseUrl, queryData);
    return axios.get(url, AxiosHelper.getOptionsWithApiKeyHeader(apiKey, apiSecret));
}

export function postWithApiKey(baseUrl, bodyData, apiKey, apiSecret) {
    var url = AxiosHelper.getUrl(baseUrl, null);
    return axios.post(url, bodyData, AxiosHelper.getOptionsWithApiKeyHeader(apiKey, apiSecret));
}
export function putWithApiKey(baseUrl, bodyData, apiKey, apiSecret) {
    var url = AxiosHelper.getUrl(baseUrl, null);
    return axios.put(url, bodyData, AxiosHelper.getOptionsWithApiKeyHeader(apiKey, apiSecret));
}
export function patchWithApiKey(baseUrl, bodyData, apiKey, apiSecret) {
    var url = AxiosHelper.getUrl(baseUrl, null);
    return axios.patch(url, bodyData, AxiosHelper.getOptionsWithApiKeyHeader(apiKey, apiSecret));
}
export function delWithApiKey(baseUrl, queryData, apiKey, apiSecret) {
    var url = AxiosHelper.getUrl(baseUrl, queryData);
    return axios.delete(url, AxiosHelper.getOptionsWithApiKeyHeader(apiKey, apiSecret));
}